import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.market.cart.discount.bulk;

const { actions, reducer, sagas, selectors, additionalSagas } = createAPIModule(
	{
		getStateSlice,
		actionType: 'MARKET_CART_DISCOUNT_BULK',
		url: '/market/cart/discount/bulk.json',
	},
);

export {
	actions as cartDiscountBulkActions,
	reducer as cartDiscountBulkReducer,
	sagas as cartDiscountBulkSagas,
	selectors as cartDiscountBulkSelectors,
	additionalSagas as cartDiscountBulkAdditionalSagas,
};
